import axios from "axios";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const StepEncerramento = ({ caseId, encerramento, onChange, onSave, getAuthHeaders, readOnly }) => {
  const data = encerramento || {};
  const update = (field, value) => onChange({ ...data, [field]: value });

  const handleExport = async () => {
    try {
      const response = await axios.get(`${API}/cases/${caseId}/export`, {
        headers: getAuthHeaders(),
        responseType: "blob"
      });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "perytus-laudo.docx";
      link.click();
      window.URL.revokeObjectURL(url);
    } catch {
      toast.error("Erro ao exportar documento");
    }
  };

  return (
    <Card>
      <CardHeader><CardTitle>Encerramento</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <div><Label>Conclusão</Label><Textarea value={data.conclusao || ""} disabled={readOnly} onChange={(e) => update("conclusao", e.target.value)} /></div>
        <div><Label>Observação sobre amplitude técnica</Label><Textarea value={data.observacao_amplitude_tecnica || ""} disabled={readOnly} onChange={(e) => update("observacao_amplitude_tecnica", e.target.value)} /></div>
        <div><Label>Lacunas metodológicas</Label><Textarea value={data.lacunas_metodologicas || ""} disabled={readOnly} onChange={(e) => update("lacunas_metodologicas", e.target.value)} /></div>
        <div><Label>Referências bibliográficas</Label><Textarea value={data.referencias_bibliograficas || ""} disabled={readOnly} onChange={(e) => update("referencias_bibliograficas", e.target.value)} /></div>
        <div className="grid grid-cols-2 gap-4">
          <div><Label>Volume de documentos</Label><Input value={data.volume_documentos || "baixo"} disabled={readOnly} onChange={(e) => update("volume_documentos", e.target.value)} /></div>
          <div><Label>Quantidade de fotos</Label><Input type="number" value={data.quantidade_fotos_estimativa || 0} disabled={readOnly} onChange={(e) => update("quantidade_fotos_estimativa", Number(e.target.value))} /></div>
        </div>
        <div><Label>Ajuste manual (horas)</Label><Input type="number" step="0.5" value={data.ajuste_manual_horas || 0} disabled={readOnly} onChange={(e) => update("ajuste_manual_horas", Number(e.target.value))} /></div>
        {!readOnly && <Button onClick={() => onSave(data)}>Salvar</Button>}
        <Button variant="outline" onClick={handleExport}><Download size={16} className="mr-2" /> Exportar Word</Button>
      </CardContent>
    </Card>
  );
};

export default StepEncerramento;
